module.exports = __webpack_public_path__ + "summernote.9cd6e041544b63fb70f4.eot";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/vendors/by_bower/summernote/dist/font/summernote.eot
// module id = ../../../../../src/assets/vendors/by_bower/summernote/dist/font/summernote.eot
// module chunks = styles